import React, {useRef} from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  View,
  useWindowDimensions,
} from 'react-native';
import {
  ActivityIndicator,
  Banner,
  Divider,
  IconButton,
  useTheme,
} from 'react-native-paper';
import {useMutation, useQuery} from 'react-query';
import {Media} from '../../../types';
import {getFileOpfs, getVideoWT} from '../../../api/media';
import {useIsFocused} from '@react-navigation/native';
import {
  MediaActionType,
  loaded,
  togglePause,
} from '../../../store/slices/media';
import {useAppDispatch} from '../../../store/hooks';
import {useMediaPlayer} from '../../../hooks/useMediaPlayer';
export default function MediaBanner({
  height,
  mediaPlayer,
}: {
  mediaPlayer: ReturnType<typeof useMediaPlayer>;
  height: number;
}) {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const {currentMediaId, currentMedia} = mediaPlayer;
  const fileType = currentMedia?.fileType || currentMedia?.type;
  const isImage =
    fileType?.split('/')[0] === 'image' ||
    fileType?.search('image') > -1;
  const {width} = useWindowDimensions();
  const focused = useIsFocused();
  const mediaRes = currentMedia as Media;
  const updateMediaTime = useMutation(
    async (currentTime: number) => {
      if (mediaRes) {
        // mediaRes.currentPosition = currentTime;
        // await writeItem(mediaRes)
        // await mediaData.refetch()
      }
    },
    {retry: false},
  );

  const mediaQuery = useQuery(
    'wtMedia_' + currentMediaId,
    async () => {
      let file: string | undefined;

      try {
        file = await getFileOpfs(mediaRes);
      } catch (err) {}
      if (!file && mediaRes.url?.search('https://') > -1)
        file = mediaRes.url;
      if (!file) file = (await getVideoWT(mediaRes)).stream;
      if (typeof file === 'string')
        file = file.replace('file://', '');
      dispatch(
        loaded({
          actionType: MediaActionType.loaded,
          mediaId: currentMediaId!,
        }),
      );
      return file;
    },
    {
      enabled: focused ? true : false,
      refetchOnMount: true,
    },
  );
  const mediaLoading = mediaQuery.isLoading;
  const mediaSrc = mediaQuery?.data;
  const currentPosition = mediaRes?.currentPosition || 0;
  const isMobile = width < 700;
  const bannerHeight = parseInt(
    isMobile ? height / 4 : height / 2,
    10,
  );
  const videoRef = useRef();
  return (
    <>
      <Banner
        visible={currentMediaId ? true : false}
        theme={theme}
        style={{
          backgroundColor: 'black',
          padding: 0,
          margin: '0 !important',
          width,
          height: bannerHeight,
          position: 'static',
          display: 'flex',
          alignItems: 'center',
          alignContent: 'center',
        }}
        contentStyle={{
          width: isMobile ? width : '100%',
          height: bannerHeight,
          padding: 0,
          margin: '0 !important',
        }}>
        <View
          style={{
            width: isMobile ? width : '100%',
            height: bannerHeight - 40,
            margin: '0 !important',
            padding: '0 !important',
            position: 'absolute',
          }}>
          {isImage && currentMediaId && mediaSrc && (
            <ImageBackground
              style={{
                height: '100%',
                width: '100%',
                margin: 0,
                padding: 0,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                position: 'absolute',
              }}
              resizeMethod="scale"
              imageStyle={{resizeMode: 'contain'}}
              // imageStyle={{width: '100%', height: '100%'}}
              source={{
                uri: Platform.select({
                  web: mediaSrc,
                  ios: 'file://' + mediaSrc.replace('file://', ''),
                  android:
                    'file://' + mediaSrc.replace('file://', ''),
                }),
              }}
            />
          )}
          {!isImage && currentMediaId && mediaSrc ? (
            Platform.OS === 'web' ? (
              <>
                <video
                  // autoPlay={!media.isMediaPaused ? true : false}
                  controls={true}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    position: 'absolute',
                  }}
                  onPlaying={e => {
                    const {currentTime} = e.nativeEvent
                      .target as any as {currentTime: number};
                    updateMediaTime.mutateAsync(currentTime);
                    dispatch(
                      togglePause({
                        pause: false,
                        actionType: MediaActionType.pause,
                      }),
                    );
                  }}
                  onPause={e => {
                    dispatch(
                      togglePause({
                        pause: true,
                        actionType: MediaActionType.pause,
                      }),
                    );
                  }}
                  onEnded={p => {
                    console.info('ended', p);
                  }}
                  onTimeUpdate={e => {
                    const {currentTime} = e.nativeEvent
                      .target as any as {currentTime: number};
                    // console.info('time', currentTime)
                    const minimumTimeDiff = 5;
                    if (
                      currentTime > minimumTimeDiff &&
                      currentTime - currentPosition >
                        minimumTimeDiff &&
                      !updateMediaTime.isLoading
                    ) {
                      updateMediaTime.mutateAsync(currentTime);
                    }
                  }}
                  onResize={() => {
                    console.info('resize');
                  }}
                  onLoadedData={e => {
                    if (!mediaPlayer.isMediaPaused)
                      e.nativeEvent.target.play();
                  }}
                  ref={el => {
                    // console.info("onmount", el)
                    if (
                      el &&
                      el.paused &&
                      el.currentTime !== currentPosition
                    ) {
                      // el.currentTime = currentPosition
                    }
                  }}
                  src={mediaSrc}>
                  <track
                    label="language one"
                    kind="subtitles"
                    srcLang="en"
                    default
                  />
                </video>
                <IconButton
                  style={{
                    position: 'absolute',
                    cursor: 'pointer',
                    right: Platform.select({native: 10, web: 0}),
                    top: Platform.select({native: -20, web: 0}),
                    pointerEvents: 'auto',
                    zIndex: 100,
                  }}
                  icon={'close'}
                  mode="outlined"
                  size={25}
                  onPress={() => mediaPlayer.onMediaPress('')}
                />
              </>
            ) : null
          ) : null}
          {mediaLoading ? (
            <ActivityIndicator
              style={{position: 'relative', flexBasis: 'auto'}}
              size={72}
            />
          ) : null}
        </View>
      </Banner>
      <Divider />
    </>
  );
}
